<template>
  <div id="app">
    <HomeVue></HomeVue>
    <transition name="fade">
      <div class="top" v-if="isVisible" @click="moveUp">
        <button class="top-btn"><i class="fa-solid fa-arrow-up"></i></button>
      </div>
    </transition>
  </div>
</template>

<script>
  import HomeVue from "./components/HomeVue.vue";

  export default {
    name: "App",
    components: { HomeVue },
    data() {
      return {
        isVisible: window.scrollY > 50,
      };
    },
    created() {
      window.addEventListener("scroll", this.onScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
      moveUp() {
        window.scrollTo(0, 0);
      },
      onScroll() {
        if (window.scrollY > 150) {
          this.isVisible = true;
        } else {
          this.isVisible = false;
        }
      },
    },
  };
</script>

<style>
  #app {
    position: relative;
  }
  :root {
    --color-primary: #6a6a6a;
    --color-secondary: #414141;
    --color-tertiary: #919191;
    --color-green: #14c38e;
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body,
  html {
    font-family: "Poppins", sans-serif;
    font-size: 14px;
    text-rendering: optimizeLegibility;
    color: #a1a1a1;
    background-color: #fff;
    scroll-behavior: smooth;
  }

  .container {
    width: 1140px;
    margin: 0 auto;
  }

  section {
    padding: 80px 0px;
  }

  /* Primary Button Style */
  .btn-primary {
    margin-top: 30px;
    padding: 10px 50px;
    background: transparent;
    border: 1px solid var(--color-green);
    border-radius: 10px;
    cursor: pointer;
    font-size: 1.5em;
    font-weight: 600;
    transition: all.5s;
    color: var(--color-secondary);
  }
  .btn-primary:hover {
    color: #ffff;
    background: var(--color-green);
  }

  /* Secondary Button Style */
  .btn-secondary {
    margin-top: 20px;
    padding: 10px 50px;
    background: var(--color-green);
    border: 1px solid var(--color-green);
    border-radius: 10px;
    cursor: pointer;
    font-size: 1.5em;
    font-weight: 600;
    transition: all.5s;
    color: #ffff;
  }
  .btn-secondary:hover {
    color: var(--color-secondary);
    background: transparent;
  }

  /* Section Heading Style */
  .section-heading {
    text-align: center;
    color: var(--color-secondary);
    font-size: 2.5em;
    width: max-content;
    margin: 0 auto;
    margin-bottom: 60px !important;
  }
  .section-heading::after {
    content: "";
    width: 30%;
    background-color: var(--color-green);
    height: 5px;
    display: block;
    transition: all 0.5s;
  }

  .section-heading:hover.section-heading::after {
    width: 100%;
  }

  .top-btn {
    position: fixed;
    top: 85vh;
    right: 30px;
    padding: 15px 15px;
    background: var(--color-green);
    border-radius: 50%;
    font-size: 1.3em;
    color: white;
    border: 1px solid transparent;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Responsive */

  @media only screen and (max-width: 1200px) {
    .container {
      width: 100%;
      padding: 0 30px;
    }
  }
  @media only screen and (max-width: 767px) {
    body {
      font-size: 13px;
    }
    .container {
      padding: 0 10%;
    }
    section {
      padding: 50px 0;
    }

    .top-btn {
      top: 90vh;
      right: 20px;
    }
  }

  @media only screen and (max-width: 480px) {
    .container {
      width: 100%;
      padding: 0 20px;
    }
    section {
      padding: 60px 0;
    }
    .btn-primary,
    .btn-secondary {
      margin-top: 30px;
      padding: 10px 30px;
      font-size: 1.3em;
    }
    .section-heading {
      font-size: 2em;
      margin-bottom: 40px !important;
    }
  }
  .page-enter-active {
    animation: bounce-in 0.8s;
  }

  .page-leave-active {
    animation: bounce-out 0.5s;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0.9);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes bounce-out {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.9);
      opacity: 0;
    }
  }

  .slick-dots {
    position: absolute;
    bottom: -55px !important;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }

  .slick-dots li {
    position: relative;
    display: inline-block;
    width: 20px !important;
    height: 20px !important;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 22px !important;
    height: 22px !important;
    padding: 2px !important;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:before {
    font-family: "slick" !important;
    font-size: 10px !important;
    line-height: 16px !important;
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 15px !important;
    height: 15px !important;
    content: "•" !important;
    text-align: center !important;
    opacity: 0.25 !important;
    color: rgb(82, 76, 76) !important;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    border: 3px solid var(--color-primary) !important;
    border-radius: 50% !important;
    -webkit-border-radius: 50% !important;
    -moz-border-radius: 50% !important;
    -ms-border-radius: 50% !important;
    -o-border-radius: 50% !important;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1 !important;
    color: var(--color-green) !important;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
